import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm0 18.182c-4.512 0-8.182-3.67-8.182-8.182 0-4.511 3.67-8.182 8.182-8.182 4.512 0 8.182 3.67 8.182 8.182 0 4.512-3.67 8.182-8.182 8.182Zm0-13.94a1.213 1.213 0 1 0 1.212 1.213c0-.669-.544-1.213-1.212-1.213Zm-.91 5.152a.91.91 0 0 1 1.82 0v5.455a.91.91 0 0 1-1.82 0v-5.455Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInfo;
